import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["Quantity"];
import "core-js/modules/es.array.sort.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// src/add-line-item-helper/add-line-item-helper.ts
import { getLinkedServices } from "@printdeal/business-logic";

// src/custom-line-item-helper/custom-line-item-helper.ts
var CustomLineItemHelper = class _CustomLineItemHelper {
  static isCustomLineItemOfType(customLineItem, type) {
    var _customLineItem$custo;
    return ((_customLineItem$custo = customLineItem.custom) === null || _customLineItem$custo === void 0 ? void 0 : _customLineItem$custo.fields.lineItemType) === type;
  }
  static getCustomLineItemsOfType(customLineItems, type) {
    return customLineItems.filter(customLineItem => this.isCustomLineItemOfType(customLineItem, type));
  }
  static getCustomLineItemsByLineItemReference(customLineItems, lineItemId) {
    return customLineItems.filter(customLineItem => {
      var _customLineItem$custo2;
      return ((_customLineItem$custo2 = customLineItem.custom) === null || _customLineItem$custo2 === void 0 ? void 0 : _customLineItem$custo2.fields.lineItemReference) === lineItemId;
    });
  }
  static getAssociatedCustomLineItems(customLineItems, lineItemId, type) {
    const associatedCustomLineItems = _CustomLineItemHelper.getCustomLineItemsByLineItemReference(customLineItems, lineItemId);
    if (type) {
      return associatedCustomLineItems.filter(customLineItem => _CustomLineItemHelper.isCustomLineItemOfType(customLineItem, type));
    }
    return associatedCustomLineItems;
  }
};

// src/add-line-item-helper/add-line-item-helper.ts
import { keyValueObjectToStringArray } from "@printdeal/transformers";
var AddLineItemHelper = class _AddLineItemHelper {
  static buildLineItemShape(properties) {
    var _properties$quantity;
    const {
        userSelection: {
          Quantity: quantity
        }
      } = properties,
      userSelection = _objectWithoutProperties(properties.userSelection, _excluded);
    if (!properties.productVersion && !properties.variantSku || properties.productVersion && properties.variantSku) {
      throw new Error('Either "productVersion" or "variantSku" must be provided, not both.');
    }
    return _objectSpread(_objectSpread(_objectSpread({
      quantity: (_properties$quantity = properties.quantity) !== null && _properties$quantity !== void 0 ? _properties$quantity : Number(quantity),
      product: _objectSpread(_objectSpread(_objectSpread({
        productId: properties.productId,
        productKey: properties.productKey
      }, properties.productVersion && {
        productVersion: properties.productVersion
      }), properties.variantSku && {
        variantSku: properties.variantSku
      }), {}, {
        userSelection
      })
    }, properties.deliveryOptionId && {
      shipping: {
        deliveryOptionId: properties.deliveryOptionId
      }
    }), {}, {
      services: properties.services,
      reorderOriginalLineItemNumber: properties.reorderOriginalLineItemNumber,
      files: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, (properties.documentReferenceUrl || properties.mcpDocumentsSource) && {
        mcp: {
          mcpDocumentsSource: properties.documentReferenceUrl ? ["DocumentReferenceUrl:".concat(properties.documentReferenceUrl)] : properties.mcpDocumentsSource
        }
      }), (properties.manufacturingReadyDocumentUrl || properties.mrdMetadata) && {
        manufacturingReadyDocument: {
          url: properties.manufacturingReadyDocumentUrl,
          metadata: properties.mrdMetadata
        }
      }), (properties.userUploadsUrl || properties.userUploadComplete) && {
        userUploads: {
          url: properties.userUploadsUrl,
          complete: properties.userUploadComplete
        }
      }), {}, {
        editorType: properties.editorType
      })
    }, (properties.skipReview || properties.groupId || properties.isGroupLead) && {
      review: {
        skip: properties.skipReview,
        group: {
          id: properties.groupId,
          isLead: properties.isGroupLead
        }
      }
    }), {}, {
      fulfillmentGroupId: properties.fulfillmentGroupId,
      multipleDesignsGroup: properties.multipleDesignsGroup
    }, properties.orchestration && {
      orchestration: properties.orchestration
    });
  }
  static buildLineItemShapeFromLineItems(_ref) {
    let {
      orderOrCart,
      lineItems,
      isReorder = false,
      isWithFile = false,
      artworks
    } = _ref;
    return {
      lineItems: lineItems.map(lineItem => {
        var _lineItem$custom, _lineItem$custom2, _lineItem$custom3, _lineItem$custom4, _lineItem$custom5, _lineItem$custom6, _lineItem$custom7, _lineItem$custom8, _lineItem$custom9, _lineItem$custom10, _lineItem$custom11, _lineItem$custom12, _lineItem$custom13, _shippingCustomLineIt, _lineItem$custom14, _lineItem$custom15, _lineItem$custom16, _lineItem$custom17, _lineItem$custom18, _lineItem$custom19;
        const servicesLineItems = getLinkedServices(lineItem.id, orderOrCart);
        const servicesKeys = servicesLineItems.length > 0 ? servicesLineItems.map(serviceLineItem => serviceLineItem.custom.fields.serviceKey) : void 0;
        const orchestration = (_lineItem$custom = lineItem.custom) !== null && _lineItem$custom !== void 0 && _lineItem$custom.fields.orchestration ? JSON.parse(lineItem.custom.fields.orchestration) : void 0;
        const [shippingCustomLineItem] = CustomLineItemHelper.getAssociatedCustomLineItems(orderOrCart.customLineItems, lineItem.id, "shipping");
        const artwork = artworks === null || artworks === void 0 ? void 0 : artworks.find(artwork2 => artwork2.lineItemId === lineItem.id);
        return _AddLineItemHelper.buildLineItemShape(_objectSpread(_objectSpread(_objectSpread({
          quantity: lineItem.quantity,
          productId: (_lineItem$custom2 = lineItem.custom) === null || _lineItem$custom2 === void 0 ? void 0 : _lineItem$custom2.fields.contentfulPageId,
          productKey: (_lineItem$custom3 = lineItem.custom) === null || _lineItem$custom3 === void 0 ? void 0 : _lineItem$custom3.fields.productKey,
          userSelection: keyValueObjectToStringArray((_lineItem$custom4 = lineItem.custom) === null || _lineItem$custom4 === void 0 ? void 0 : _lineItem$custom4.fields.userSelection),
          productVersion: (_lineItem$custom5 = lineItem.custom) === null || _lineItem$custom5 === void 0 ? void 0 : _lineItem$custom5.fields.MMProductVersion,
          variantSku: lineItem.variant.sku,
          services: isReorder ? void 0 : servicesKeys,
          groupId: (_lineItem$custom6 = lineItem.custom) === null || _lineItem$custom6 === void 0 ? void 0 : _lineItem$custom6.fields.reviewGroup,
          isGroupLead: (_lineItem$custom7 = lineItem.custom) === null || _lineItem$custom7 === void 0 ? void 0 : _lineItem$custom7.fields.isReviewGroupLead,
          multipleDesignsGroup: (_lineItem$custom8 = lineItem.custom) === null || _lineItem$custom8 === void 0 ? void 0 : _lineItem$custom8.fields.multipleDesignsGroup,
          documentReferenceUrl: (_lineItem$custom9 = lineItem.custom) === null || _lineItem$custom9 === void 0 ? void 0 : _lineItem$custom9.fields.documentReferenceUrl,
          skipReview: (_lineItem$custom10 = lineItem.custom) === null || _lineItem$custom10 === void 0 ? void 0 : _lineItem$custom10.fields.skipReview,
          fulfillmentGroupId: (_lineItem$custom11 = lineItem.custom) === null || _lineItem$custom11 === void 0 ? void 0 : _lineItem$custom11.fields.fulfillmentGroup,
          reorderOriginalLineItemNumber: isReorder ? (_lineItem$custom12 = lineItem.custom) === null || _lineItem$custom12 === void 0 ? void 0 : _lineItem$custom12.fields.lineItemNumber : void 0
        }, ((_lineItem$custom13 = lineItem.custom) === null || _lineItem$custom13 === void 0 ? void 0 : _lineItem$custom13.fields.MMProductVersion) && ((_shippingCustomLineIt = shippingCustomLineItem.custom) === null || _shippingCustomLineIt === void 0 ? void 0 : _shippingCustomLineIt.fields.eCommerceDeliveryOptionId) && {
          deliveryOptionId: shippingCustomLineItem.custom.fields.eCommerceDeliveryOptionId
        }), isWithFile && _objectSpread({
          userUploadsUrl: (_lineItem$custom14 = lineItem.custom) === null || _lineItem$custom14 === void 0 ? void 0 : _lineItem$custom14.fields.userUploadsUrl,
          userUploadComplete: (_lineItem$custom15 = lineItem.custom) === null || _lineItem$custom15 === void 0 ? void 0 : _lineItem$custom15.fields.userUploadComplete,
          editorType: (_lineItem$custom16 = lineItem.custom) === null || _lineItem$custom16 === void 0 ? void 0 : _lineItem$custom16.fields.editorType
        }, (((_lineItem$custom17 = lineItem.custom) === null || _lineItem$custom17 === void 0 ? void 0 : _lineItem$custom17.fields.manufacturingReadyDocumentUrl) || ((_lineItem$custom18 = lineItem.custom) === null || _lineItem$custom18 === void 0 ? void 0 : _lineItem$custom18.fields.mcpDocumentsSource)) && {
          mcpDocumentsSource: artwork === null || artwork === void 0 ? void 0 : artwork.mcpDocumentsSource,
          manufacturingReadyDocumentUrl: lineItem.custom.fields.manufacturingReadyDocumentUrl,
          mrdMetadata: lineItem.custom.fields.mrdMetadata,
          skipReview: artwork === null || artwork === void 0 ? void 0 : artwork.skipReview
        })), (_lineItem$custom19 = lineItem.custom) !== null && _lineItem$custom19 !== void 0 && _lineItem$custom19.fields.orchestrationId && lineItem.custom.fields.orchestration ? {
          orchestration: {
            id: lineItem.custom.fields.orchestrationId,
            groupId: lineItem.custom.fields.serviceGroup,
            recipient: orchestration === null || orchestration === void 0 ? void 0 : orchestration.recipient,
            serviceParams: {
              serviceKey: lineItem.custom.fields.serviceKey,
              serviceLevel: lineItem.custom.fields.serviceLevel,
              serviceType: lineItem.custom.fields.serviceType,
              serviceName: lineItem.custom.fields.serviceName
            },
            itemOrchestration: orchestration === null || orchestration === void 0 ? void 0 : orchestration.itemOrchestration
          }
        } : {}));
      })
    };
  }
};

// src/line-item-helper/line-item-helper.ts
import { keyValueObjectToStringArray as keyValueObjectToStringArray2 } from "@printdeal/transformers";
var LineItemHelper = class _LineItemHelper {
  static hasLineItemReviewGroup(lineItem) {
    var _lineItem$custom20;
    return Boolean((_lineItem$custom20 = lineItem.custom) === null || _lineItem$custom20 === void 0 ? void 0 : _lineItem$custom20.fields.reviewGroup);
  }
  static isLineItemReviewGroupLead(lineItem) {
    var _lineItem$custom21;
    return Boolean((_lineItem$custom21 = lineItem.custom) === null || _lineItem$custom21 === void 0 ? void 0 : _lineItem$custom21.fields.isReviewGroupLead);
  }
  static isLineItemReviewGroupMember(lineItem, groupId) {
    var _lineItem$custom22;
    return ((_lineItem$custom22 = lineItem.custom) === null || _lineItem$custom22 === void 0 ? void 0 : _lineItem$custom22.fields.reviewGroup) === groupId;
  }
  static hasLineItemMultipleDesignsGroup(lineItem) {
    var _lineItem$custom23;
    return Boolean((_lineItem$custom23 = lineItem.custom) === null || _lineItem$custom23 === void 0 ? void 0 : _lineItem$custom23.fields.multipleDesignsGroup);
  }
  static isLineItemMultipleDesignsGroupMember(lineItem, groupId) {
    var _lineItem$custom24;
    return ((_lineItem$custom24 = lineItem.custom) === null || _lineItem$custom24 === void 0 ? void 0 : _lineItem$custom24.fields.multipleDesignsGroup) === groupId;
  }
  static hasLineItemOrchestrationsGroup(lineItem) {
    var _lineItem$custom25;
    return Boolean((_lineItem$custom25 = lineItem.custom) === null || _lineItem$custom25 === void 0 ? void 0 : _lineItem$custom25.fields.orchestrationId);
  }
  static isLineItemOrchestrationsGroupLead(lineItem) {
    var _lineItem$custom26;
    return Boolean(((_lineItem$custom26 = lineItem.custom) === null || _lineItem$custom26 === void 0 ? void 0 : _lineItem$custom26.fields.orchestration) && lineItem.custom.fields.recipient === "customer");
  }
  static isLineItemOrchestrationsGroupMember(lineItem, orchestrationId) {
    var _lineItem$custom27;
    return ((_lineItem$custom27 = lineItem.custom) === null || _lineItem$custom27 === void 0 ? void 0 : _lineItem$custom27.fields.orchestrationId) === orchestrationId;
  }
  static getLineItemGroupType(lineItem) {
    if (_LineItemHelper.hasLineItemReviewGroup(lineItem)) {
      return "textile";
    }
    if (_LineItemHelper.hasLineItemMultipleDesignsGroup(lineItem)) {
      return "multipleDesigns";
    }
    return void 0;
  }
  static isLineItemGrouped(lineItem) {
    return _LineItemHelper.hasLineItemReviewGroup(lineItem) || _LineItemHelper.hasLineItemMultipleDesignsGroup(lineItem) || _LineItemHelper.hasLineItemOrchestrationsGroup(lineItem);
  }
  static getLineItemQuantity(entity, lineItem) {
    if (_LineItemHelper.isLineItemReviewGroupLead(lineItem)) {
      const reviewGroup = EntityHelper.getReviewGroup(entity, lineItem.custom.fields.reviewGroup);
      return reviewGroup.reduce((acc, lineItem2) => acc + lineItem2.quantity, 0);
    }
    if (_LineItemHelper.hasLineItemMultipleDesignsGroup(lineItem)) {
      const multipleDesignsGroup = EntityHelper.getMultipleDesignsGroup(entity, lineItem.custom.fields.multipleDesignsGroup);
      return multipleDesignsGroup.reduce((acc, lineItem2) => acc + lineItem2.quantity, 0);
    }
    return lineItem.quantity;
  }
  static isLineItemQuote(lineItem) {
    var _lineItem$custom28;
    return Boolean((_lineItem$custom28 = lineItem.custom) === null || _lineItem$custom28 === void 0 ? void 0 : _lineItem$custom28.fields.quoteId);
  }
  static hasLineItemPickupPoint(lineItem) {
    var _lineItem$custom29;
    return Boolean(((_lineItem$custom29 = lineItem.custom) === null || _lineItem$custom29 === void 0 ? void 0 : _lineItem$custom29.fields.isWithPickupLocation) && lineItem.custom.fields.pickupPoint);
  }
  static hasLineItemTimedDelivery(lineItem) {
    var _lineItem$custom30;
    return Boolean((_lineItem$custom30 = lineItem.custom) === null || _lineItem$custom30 === void 0 ? void 0 : _lineItem$custom30.fields.timedDelivery);
  }
  static hasLineItemSplitShipment(lineItem) {
    var _lineItem$custom31;
    return Boolean(((_lineItem$custom31 = lineItem.custom) === null || _lineItem$custom31 === void 0 || (_lineItem$custom31 = _lineItem$custom31.fields.shippingAddressPerLineItem) === null || _lineItem$custom31 === void 0 ? void 0 : _lineItem$custom31.length) && lineItem.custom.fields.shippingAddressPerLineItem.length > 1);
  }
  static getLineItemShippingAddresses(lineItem) {
    var _lineItem$custom32;
    if (!((_lineItem$custom32 = lineItem.custom) !== null && _lineItem$custom32 !== void 0 && _lineItem$custom32.fields.shippingAddressPerLineItem)) {
      return void 0;
    }
    return lineItem.custom.fields.shippingAddressPerLineItem.map(address => {
      return keyValueObjectToStringArray2(address);
    });
  }
  static getLineItemPickupPointId(lineItem) {
    if (!_LineItemHelper.hasLineItemPickupPoint(lineItem)) {
      return void 0;
    }
    try {
      var _pickupPoint$href;
      const pickupPoint = JSON.parse(lineItem.custom.fields.pickupPoint);
      if (!((_pickupPoint$href = pickupPoint.href) !== null && _pickupPoint$href !== void 0 && _pickupPoint$href.includes("/v1/pickupPoints/"))) {
        return void 0;
      }
      const pickupPointId = pickupPoint.href.split("/v1/pickupPoints/").pop();
      return pickupPointId ? decodeURIComponent(pickupPointId) : void 0;
    } catch (_unused) {
      return void 0;
    }
  }
  static getLineItemEcommerceDeliveryOptionId(lineItem) {
    var _lineItem$custom33;
    return (_lineItem$custom33 = lineItem.custom) === null || _lineItem$custom33 === void 0 ? void 0 : _lineItem$custom33.fields.eCommerceDeliveryOptionId;
  }
};

// src/entity-helper/entity-helper.ts
var EntityHelper = class _EntityHelper {
  static isCart(entity) {
    return "cartState" in entity;
  }
  static isOrder(entity) {
    return "orderState" in entity;
  }
  static getMainLineItems(entity) {
    const filteredLineItems = entity.lineItems.filter(lineItem => {
      if (!LineItemHelper.hasLineItemReviewGroup(lineItem)) {
        return true;
      }
      return LineItemHelper.isLineItemReviewGroupLead(lineItem);
    });
    const seenMultipleDesignGroups = /* @__PURE__ */new Set();
    return filteredLineItems.filter(lineItem => {
      var _lineItem$custom34;
      const multipleDesignsGroup = (_lineItem$custom34 = lineItem.custom) === null || _lineItem$custom34 === void 0 ? void 0 : _lineItem$custom34.fields.multipleDesignsGroup;
      if (!multipleDesignsGroup) {
        return true;
      }
      if (seenMultipleDesignGroups.has(multipleDesignsGroup)) {
        return false;
      }
      seenMultipleDesignGroups.add(multipleDesignsGroup);
      return true;
    });
  }
  static getVisibleCartChangeAfterLogin(cartBeforeLogin, cartAfterLogin) {
    const didCartChange = cartAfterLogin && cartAfterLogin.id !== (cartBeforeLogin === null || cartBeforeLogin === void 0 ? void 0 : cartBeforeLogin.id);
    const mainLineItemsBeforeLogin = cartBeforeLogin ? _EntityHelper.getMainLineItems(cartBeforeLogin) : [];
    const mainLineItemsAfterLogin = cartAfterLogin ? _EntityHelper.getMainLineItems(cartAfterLogin) : [];
    if (didCartChange && mainLineItemsAfterLogin.length) {
      if (!cartBeforeLogin) {
        return "retrievedCart";
      }
      if (mainLineItemsAfterLogin.length > mainLineItemsBeforeLogin.length) {
        return "mergedCart";
      }
    }
    return "none";
  }
  static getReviewGroup(entity, groupId) {
    return entity.lineItems.filter(lineItem => LineItemHelper.isLineItemReviewGroupMember(lineItem, groupId));
  }
  static getMultipleDesignsGroup(entity, groupId) {
    return entity.lineItems.filter(lineItem => LineItemHelper.isLineItemMultipleDesignsGroupMember(lineItem, groupId));
  }
  static getLastUpdatedPayment(entity) {
    var _entity$paymentInfo, _sort$shift;
    if (!((_entity$paymentInfo = entity.paymentInfo) !== null && _entity$paymentInfo !== void 0 && _entity$paymentInfo.payments.length)) {
      return void 0;
    }
    return (_sort$shift = [...entity.paymentInfo.payments].sort((a, b) => {
      var _a$obj$lastModifiedAt, _a$obj, _b$obj$lastModifiedAt, _b$obj;
      const aDate = new Date((_a$obj$lastModifiedAt = (_a$obj = a.obj) === null || _a$obj === void 0 ? void 0 : _a$obj.lastModifiedAt) !== null && _a$obj$lastModifiedAt !== void 0 ? _a$obj$lastModifiedAt : "");
      const bDate = new Date((_b$obj$lastModifiedAt = (_b$obj = b.obj) === null || _b$obj === void 0 ? void 0 : _b$obj.lastModifiedAt) !== null && _b$obj$lastModifiedAt !== void 0 ? _b$obj$lastModifiedAt : "");
      return bDate.getTime() - aDate.getTime();
    }).shift()) === null || _sort$shift === void 0 ? void 0 : _sort$shift.obj;
  }
  // TODO: Check with Bjorn/Rogier if we need this method and reuse getMainLineItems instead
  static getMainGroupedLineItems(entity) {
    const seenMultipleDesignsGroups = /* @__PURE__ */new Set();
    return entity.lineItems.filter(lineItem => {
      if (!LineItemHelper.isLineItemGrouped(lineItem)) {
        return true;
      }
      if (LineItemHelper.isLineItemOrchestrationsGroupLead(lineItem)) {
        return true;
      }
      if (LineItemHelper.isLineItemReviewGroupLead(lineItem)) {
        return true;
      }
      if (LineItemHelper.hasLineItemMultipleDesignsGroup(lineItem)) {
        const multipleDesignsGroup = lineItem.custom.fields.multipleDesignsGroup;
        if (seenMultipleDesignsGroups.has(multipleDesignsGroup)) {
          return false;
        }
        seenMultipleDesignsGroups.add(multipleDesignsGroup);
        return true;
      }
      return false;
    });
  }
  static hasQuoteLineItems(entity) {
    return entity.lineItems.some(lineItem => LineItemHelper.isLineItemQuote(lineItem));
  }
  static hasPaymentInfo(entity) {
    var _entity$paymentInfo2;
    return Boolean((_entity$paymentInfo2 = entity.paymentInfo) === null || _entity$paymentInfo2 === void 0 ? void 0 : _entity$paymentInfo2.payments.length);
  }
};

// src/address-helper/address-helper.ts
import { keyValueObjectToStringArray as keyValueObjectToStringArray3 } from "@printdeal/transformers";
var AddressHelper = class _AddressHelper {
  static isAddressComplete(address) {
    return Boolean(address.firstName && address.lastName && address.streetName && address.streetNumber && address.postalCode && address.city && address.country);
  }
  static isShippingAddressValidOnEntity(entity) {
    var _entity$shippingAddre;
    if (!((_entity$shippingAddre = entity.shippingAddress) !== null && _entity$shippingAddre !== void 0 && _entity$shippingAddre.country)) {
      return false;
    }
    return !Boolean(EntityHelper.getMainLineItems(entity).filter(lineItem => !LineItemHelper.hasLineItemPickupPoint(lineItem)).find(lineItem => {
      var _lineItem$custom35;
      return !((_lineItem$custom35 = lineItem.custom) !== null && _lineItem$custom35 !== void 0 && (_lineItem$custom35 = _lineItem$custom35.fields.shippingAddressPerLineItem) !== null && _lineItem$custom35 !== void 0 && _lineItem$custom35.length) || lineItem.custom.fields.shippingAddressPerLineItem.find(address => {
        const parsedAddress = keyValueObjectToStringArray3(address);
        return !_AddressHelper.isAddressComplete(parsedAddress);
      });
    }));
  }
  static isShippingAddressCountryValidOnEntity(entity, validCountries) {
    if (!entity.shippingAddress) {
      return false;
    }
    if (!validCountries.includes(entity.shippingAddress.country)) {
      return false;
    }
    return !Boolean(EntityHelper.getMainLineItems(entity).filter(lineItem => !LineItemHelper.hasLineItemPickupPoint(lineItem)).find(lineItem => {
      var _lineItem$custom36;
      return !((_lineItem$custom36 = lineItem.custom) !== null && _lineItem$custom36 !== void 0 && (_lineItem$custom36 = _lineItem$custom36.fields.shippingAddressPerLineItem) !== null && _lineItem$custom36 !== void 0 && _lineItem$custom36.length) || lineItem.custom.fields.shippingAddressPerLineItem.find(address => {
        const parsedAddress = keyValueObjectToStringArray3(address);
        return !validCountries.includes(parsedAddress.country);
      });
    }));
  }
  static isBillingAddressValidOnEntity(entity) {
    if (!entity.billingAddress) {
      return false;
    }
    if (!entity.billingAddress.email) {
      return false;
    }
    return _AddressHelper.isAddressComplete(entity.billingAddress);
  }
  static isBillingAddressCountryValidOnEntity(entity, validCountries) {
    if (!entity.billingAddress) {
      return false;
    }
    return validCountries.includes(entity.billingAddress.country);
  }
};

// src/carrier-option-helper/carrier-option-helper.ts
var CarrierOptionHelper = class _CarrierOptionHelper {
  static getNumberOfCarrierOptions(options) {
    return new Set(options.map(option => option.carrier)).size;
  }
  static getTimedDeliveryFromLineItem(lineItem) {
    var _lineItem$custom37;
    if (!((_lineItem$custom37 = lineItem.custom) !== null && _lineItem$custom37 !== void 0 && _lineItem$custom37.fields.timedDelivery)) {
      return void 0;
    }
    try {
      return JSON.parse(lineItem.custom.fields.timedDelivery);
    } catch (_unused2) {
      return void 0;
    }
  }
  static getCarrierOptionFromLineItem(lineItem, options) {
    var _lineItem$custom38;
    const timedDelivery = _CarrierOptionHelper.getTimedDeliveryFromLineItem(lineItem);
    const carrierKeys = (_lineItem$custom38 = lineItem.custom) === null || _lineItem$custom38 === void 0 ? void 0 : _lineItem$custom38.fields.qpShippingCarrierKey;
    if (!timedDelivery && !carrierKeys) {
      return void 0;
    }
    if (timedDelivery) {
      if (!carrierKeys) {
        return options.find(option => option.before === timedDelivery.before);
      }
      const matchingOption = options.find(option => {
        var _option$recsKey;
        return option.before === timedDelivery.before && ((_option$recsKey = option.recsKey) === null || _option$recsKey === void 0 ? void 0 : _option$recsKey.length) === carrierKeys.length && option.recsKey.every((recsKey, index) => carrierKeys[index] === recsKey);
      });
      return matchingOption;
    }
    if (carrierKeys) {
      const matchingOption = options.find(option => {
        var _option$recsKey2;
        return ((_option$recsKey2 = option.recsKey) === null || _option$recsKey2 === void 0 ? void 0 : _option$recsKey2.length) === carrierKeys.length && option.recsKey.every((recsKey, index) => carrierKeys[index] === recsKey);
      });
      return matchingOption;
    }
  }
};

// src/entity-response-stripper-helper/entity-response-stripper-helper.ts
var EntityResponseStripperHelper = class {
  constructor(entity) {
    this.entity = entity;
  }
  strip() {
    return _objectSpread(_objectSpread({}, this.entity), {}, {
      lineItems: this.entity.lineItems.map(lineItem => _objectSpread(_objectSpread({}, lineItem), {}, {
        custom: this.stripCustomFields(lineItem)
      })),
      customLineItems: this.entity.customLineItems.map(customLineItem => _objectSpread(_objectSpread({}, customLineItem), {}, {
        custom: this.stripCustomFields(customLineItem)
      }))
    });
  }
  stripCustomFields(item) {
    const itemsToStrip = ["websiteShippingTotals", "websiteProductTotals"];
    if (!item.custom) {
      return void 0;
    }
    const newCustomFields = Object.entries(item.custom.fields).reduce((customFields, _ref2) => {
      let [key, value] = _ref2;
      if (itemsToStrip.includes(key)) {
        return customFields;
      }
      customFields[key] = value;
      return customFields;
    }, {});
    return _objectSpread(_objectSpread({}, item.custom), {}, {
      fields: newCustomFields
    });
  }
};

// src/surface-helper/surface-helper.ts
var SurfaceHelper = class _SurfaceHelper {
  static filterRemainingOptions(options, userSelections) {
    return options.filter(option => userSelections[option]);
  }
  static shouldRemoveArtwork(options, currentUserSelection, newUserSelection) {
    return _SurfaceHelper.filterRemainingOptions(options, newUserSelection).some(option => {
      const currentValue = currentUserSelection[option];
      const newValue = newUserSelection[option];
      if (!currentValue) {
        return true;
      }
      return currentValue.toLowerCase() !== newValue.toLowerCase();
    });
  }
};

// src/validation-helper/validation-helper.ts
import { arrayOfStringArraysToArrayOfObjects } from "@printdeal/transformers";
import { klona } from "klona";
import { ValidationError } from "yup";

// src/validation-helper/schemas/cart-schema.ts
import * as yup3 from "yup";
import validator from "validator";

// src/validation-helper/schemas/postal-code-schema.ts
import * as yup from "yup";
var postalCodeSchema = yup.string().trim().required().when("country", {
  is: value => value.toLowerCase() === "nl",
  then: schema => schema.required().matches(/^[1-9][0-9]{3}\s*?[a-zA-Z]{2}$/),
  otherwise: schema => schema.min(1).matches(/^[0-9a-zA-Z\s-]*$/)
});

// src/validation-helper/schemas/shipping-address-schema.ts
import * as yup2 from "yup";
var shippingAddressSchema = yup2.object().shape({
  postalCode: postalCodeSchema,
  country: yup2.string().trim().required().length(2),
  streetNumber: yup2.string().trim().required().max(100),
  streetName: yup2.string().trim().required().max(100),
  city: yup2.string().trim().required().max(100),
  firstName: yup2.string().trim().required().max(75).test("arteriskFirstName", "Cannot be an *.", value => value !== "*"),
  lastName: yup2.string().trim().required().max(150).test("arteriskLastName", "Cannot be an *.", value => value !== "*"),
  phone: yup2.string().trim(),
  company: yup2.string().trim().max(255).test("arteriskCompany", "Cannot be an *.", value => value !== "*")
});

// src/validation-helper/schemas/cart-schema.ts
var cartSchema = yup3.object().shape({
  lineItems: yup3.array().of(yup3.object().shape({
    id: yup3.string(),
    custom: yup3.object().shape({
      fields: yup3.object().shape({
        shippingAddressPerLineItem: yup3.array().when(["isWithPickupLocation"], {
          is: isWithPickupLocation => !isWithPickupLocation,
          then: schema => schema.of(shippingAddressSchema).required()
        })
      }).required()
    }).required()
  })).required(),
  shippingAddress: yup3.object().shape({
    country: yup3.string().trim().required().length(2)
  }).required(),
  billingAddress: yup3.object().shape({
    country: yup3.string().trim().required().length(2),
    postalCode: postalCodeSchema,
    streetNumber: yup3.string().trim().required().max(100),
    streetName: yup3.string().trim().required().max(100),
    city: yup3.string().trim().required().max(100),
    firstName: yup3.string().when(["isCompany", "company", "lastName"], {
      is: (isCompany, company, lastName) => {
        return isCompany ? !company && !lastName : true;
      },
      then: schema => schema.trim().max(75).required(),
      otherwise: schema => schema.trim().max(75)
    }),
    lastName: yup3.string().when(["isCompany", "company", "firstName"], {
      is: (isCompany, company, firstName) => {
        return isCompany ? !company && !firstName : true;
      },
      then: schema => schema.trim().max(150).required(),
      otherwise: schema => schema.trim().max(150)
    }),
    phone: yup3.string().trim(),
    email: yup3.string().trim().max(255).required().email().test(email => validator.isEmail(email, {
      blacklisted_chars: "\xE0\xE8\xEC\xF2\xF9\xC0\xC8\xCC\xD2\xD9\xE1\xE9\xED\xF3\xFA\xFD\xC1\xC9\xCD\xD3\xDA\xDD\xE2\xEA\xEE\xF4\xFB\xC2\xCA\xCE\xD4\xDB\xE3\xF1\xF5\xC3\xD1\xD5\xE4\xEB\xEF\xF6\xFC\xFF\xC4\xCB\xCF\xD6\xDC\u0178\xE7\xC7\xDF\xD8\xF8\xC5\xE5\xC6\xE6\u0153",
      allow_utf8_local_part: false,
      require_tld: true
    })),
    company: yup3.string().when(["isCompany", "firstName", "lastName"], {
      is: (isCompany, firstName, lastName) => isCompany && !firstName && !lastName,
      then: schema => schema.trim().max(255).required(),
      otherwise: schema => schema.trim().max(255)
    })
  }, [["company", "lastName"], ["company", "firstName"], ["firstName", "lastName"]]),
  custom: yup3.object().shape({
    fields: yup3.object().shape({
      isCompany: yup3.bool()
    })
  })
});

// src/validation-helper/validation-helper.ts
var ValidationHelper = class {
  static async validateEntity(entity) {
    const transformEntityForValidation = () => {
      var _entity$custom;
      const transformedCart = klona(entity);
      if (((_entity$custom = entity.custom) === null || _entity$custom === void 0 ? void 0 : _entity$custom.fields.isCompany) === true) {
        if (transformedCart.shippingAddress) {
          transformedCart.shippingAddress = _objectSpread(_objectSpread({}, transformedCart.shippingAddress), {}, {
            isCompany: true
          });
        }
        if (transformedCart.billingAddress) {
          transformedCart.billingAddress = _objectSpread(_objectSpread({}, transformedCart.billingAddress), {}, {
            isCompany: true
          });
        }
      }
      transformedCart.lineItems = transformedCart.lineItems.map(lineItem => {
        var _lineItem$custom39;
        if ((_lineItem$custom39 = lineItem.custom) !== null && _lineItem$custom39 !== void 0 && _lineItem$custom39.fields.shippingAddressPerLineItem) {
          const {
            shippingAddressPerLineItem
          } = lineItem.custom.fields;
          return _objectSpread(_objectSpread({}, lineItem), {}, {
            custom: _objectSpread(_objectSpread({}, lineItem.custom), {}, {
              fields: _objectSpread(_objectSpread({}, lineItem.custom.fields), {}, {
                shippingAddressPerLineItem: arrayOfStringArraysToArrayOfObjects(shippingAddressPerLineItem)
              })
            })
          });
        }
        return lineItem;
      });
      return transformedCart;
    };
    await cartSchema.validate(transformEntityForValidation(), {
      strict: false,
      abortEarly: false,
      stripUnknown: false,
      recursive: true
    }).catch(error => {
      if (error instanceof ValidationError) {
        const rejection = {
          errorMessage: {
            statusCode: 400,
            message: "Invalid cart!",
            errors: error.inner.map(errorField => ({
              path: errorField.path,
              message: errorField.message
            })).filter((value, index, self) => self.indexOf(value) === index)
          }
        };
        return Promise.reject(rejection);
      }
      return Promise.reject(error);
    });
    return "No errors";
  }
};
export { AddLineItemHelper, AddressHelper, CarrierOptionHelper, CustomLineItemHelper, EntityHelper, EntityResponseStripperHelper, LineItemHelper, SurfaceHelper, ValidationHelper };